module.exports = __webpack_public_path__ + "23591f9d72b1e3ad2652099518e98f72.svg";